// extracted by mini-css-extract-plugin
export var chevron = "_l5-3";
export var chevronRotated = "_l5-4";
export var image = "_l5-1";
export var imageContainer = "_l5-0";
export var shippingAddress = "_l5-2";